import services from "../services";
import * as types from "./mutation-type";

export const setDeliveryTime = ({ commit }, payload) => {
    commit(types.SET_DELIVERY_TIME, payload);
};

export const setOpenCalendar = ({ commit }, payload) => {
    commit(types.SET_OPEN_CALENDAR, payload);
};

export const setCloseModalCalendar = ({ commit }, payload) => {
    commit(types.SET_CLOSE_MODAL_CALENDAR, payload);
};

export const ActionGetCalendar = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getCalendar(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionGetDeliveryTimes = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getDeliveryTimes(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionSetSessionDeliveryTime = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.setSessionDeliveryTime(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionGetSessionDeliveryTime = async ({ dispatch }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getSessionDeliveryTime();
        if (data.error === false) {
            dispatch('setDeliveryTime', data.data);
            resolve(data);
        }
        reject(data);
    });
};
